import { TextSelection } from '@tiptap/pm/state'

const handleBackspaceForPlaceholders = editor => {
  const { state, dispatch } = editor.view
  const { selection } = state

  // Only proceed if it's a cursor selection (not a range)
  if (!selection.empty || !selection.$cursor) {
    return false // Let default behavior handle it
  }

  const { $cursor } = selection
  const pos = $cursor.pos
  const nodeBefore = $cursor.nodeBefore // Get the node directly before the cursor

  if (
    nodeBefore &&
    (nodeBefore.type.name === 'dfNode' || nodeBefore.type.name === 'stNode')
  ) {
    // Cursor is immediately after our custom node
    const nodeType = nodeBefore.type.name
    const name = nodeBefore.attrs.dfName || nodeBefore.attrs.stName // Get the name attribute
    const nodeStartPos = pos - nodeBefore.nodeSize

    // Construct the text representation
    const textRepresentation =
      nodeType === 'dfNode' ? `{{df '${name}'}}` : `{{st '${name}'}}`

    // Replace the node with its text representation
    const tr = state.tr.replaceWith(
      nodeStartPos,
      pos,
      state.schema.text(textRepresentation)
    )

    // Move cursor to the end of the inserted text
    tr.setSelection(
      TextSelection.create(tr.doc, nodeStartPos + textRepresentation.length)
    )

    dispatch(tr)
    return true // We handled the keypress
  }

  return false // Let default behavior handle it
}

export const customKeymap = {
  Backspace: ({ editor }) => {
    return handleBackspaceForPlaceholders(editor)
  }
}
